import { createFileRoute, Link } from "@tanstack/react-router";
import headImg from "@/assets/public/story-manufacturing.jpg";
import { CalendarDays, MapPin } from "lucide-react";
import { PageHead, Shell } from "@/components/public/site";

export const Route = createFileRoute("/events/")({
  head: () => ({
    meta: [
      { title: "Events — Maven Scouts" },
      { name: "description", content: "Upcoming Maven Scouts events, demo days, and industry engagements across defense, energy, and dual-use technology." },
      { property: "og:title", content: "Events — Maven Scouts" },
      { property: "og:description", content: "Demo days, summits, and industry engagements from Maven Scouts." },
    ],
  }),
  component: Page,
});

const events = [
  { date: "Nov 2026", title: "Gulf South Dual-Use Demo Day", place: "New Orleans, LA", tag: "Demo Day", body: "Founders present dual-use technology to defense, energy, and government stakeholders." },
  { date: "Jan 2027", title: "Energy & Critical Infrastructure Security Forum", place: "Baton Rouge, LA", tag: "Forum", body: "Protecting Gulf Coast energy, ports, and grid assets with emerging technology." },
  { date: "Mar 2027", title: "Maritime & Autonomy Industry Day", place: "Lafayette, LA", tag: "Industry Day", body: "Connecting maritime and autonomous-systems innovators with mission owners." },
  { date: "Apr 2027", title: "SBIR/STTR Navigation Workshop", place: "Virtual", tag: "Workshop", body: "A practical session on non-dilutive funding and DoD transition pathways." },
];

function Page() {
  return (
    <Shell>
      <PageHead image={headImg} alt="Advanced manufacturing floor in the Gulf South" code="Events" title="Where the ecosystem meets" sub="Demo days, forums, and industry engagements across defense, energy, maritime, and agriculture." />
      <div className="mx-auto max-w-7xl space-y-4 px-6 py-20">
        {events.map((e) => (
          <div key={e.title} className="grid items-center gap-6 rounded-lg border border-border bg-card p-8 shadow-sm md:grid-cols-12">
            <div className="md:col-span-2">
              <p className="font-display text-2xl text-primary">{e.date}</p>
              <span className="mt-2 inline-block rounded-full bg-accent px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-primary">{e.tag}</span>
            </div>
            <div className="md:col-span-7">
              <h2 className="font-display text-2xl uppercase">{e.title}</h2>
              <p className="mt-2 text-sm text-muted-foreground">{e.body}</p>
              <p className="mt-3 flex gap-4 font-mono text-xs uppercase tracking-widest text-muted-foreground">
                <span className="flex items-center gap-1"><CalendarDays className="h-3 w-3" />{e.date}</span>
                <span className="flex items-center gap-1"><MapPin className="h-3 w-3" />{e.place}</span>
              </p>
            </div>
            <div className="md:col-span-3 md:text-right">
              <Link to="/intake" className="inline-block bg-primary px-6 py-3 font-mono text-xs uppercase tracking-widest text-primary-foreground hover:bg-secondary">Register interest</Link>
            </div>
          </div>
        ))}
      </div>
    </Shell>
  );
}
